module.exports = __webpack_public_path__ + "media/app/images/stripe_payment-f54f73c91d978565212613df5ecccf5b.png";